import { TrendingUp, Loader2 } from 'lucide-react';
import { AdminPageHeader, StatCard, useFetcher } from './_P1Common';

export default function AdminPerformanceForecast() {
  const { data, loading } = useFetcher('performance-forecast');
  if (loading || !data) return <AdminPageHeader icon={TrendingUp} title="Prognoza izvedbe"><Loader2 className="animate-spin"/></AdminPageHeader>;
  const allVals = [...data.history, ...data.forecast].map(d => d.articles ?? d.predicted_articles ?? 0);
  const max = Math.max(1, ...allVals);
  return (
    <div data-testid="admin-performance-forecast">
      <AdminPageHeader icon={TrendingUp} title="Prognoza izvedbe" subtitle="7-dnevni prosjek i prognoza za sljedećih 7 dana"/>
      <div className="px-4 md:px-6 mb-6 grid grid-cols-2 md:grid-cols-3 gap-3">
        <StatCard testid="pf-avg" label="7-dnevni prosjek" value={data.trend_avg} accent="violet"/>
      </div>
      <div className="px-4 md:px-6 pb-6">
        <div className="border border-zinc-800 rounded-lg p-4">
          <h3 className="font-bold text-sm mb-4">Historija (30 dana) + prognoza (7 dana)</h3>
          <div className="flex items-end gap-0.5 h-40">
            {data.history.map(d => (
              <div key={d.date} title={`${d.date}: ${d.articles}`} style={{ height: `${(d.articles / max) * 100}%` }}
                   className="flex-1 bg-zinc-600 rounded-t min-h-[2px]"/>
            ))}
            {data.forecast.map(d => (
              <div key={d.date} title={`${d.date}: pred ${d.predicted_articles}`}
                   style={{ height: `${(d.predicted_articles / max) * 100}%` }}
                   className="flex-1 bg-red-600 rounded-t min-h-[2px] opacity-80"/>
            ))}
          </div>
          <div className="mt-2 flex justify-between text-xs text-zinc-500">
            <span>{data.history[0]?.date}</span>
            <span>Danas</span>
            <span>+7</span>
          </div>
        </div>
      </div>
    </div>
  );
}
